<template>
    <v-card :id="id">
        <psi-card-heading
            :headingTitle="title"
            :icon="icon"
            :heading-color="headingColor"
        ></psi-card-heading>
        <v-card-text>
            <v-list subheader dense>
                <template
                    v-for="(key, j) in ['Addresses', 'Names', 'Birthdates']"
                >
                    <v-subheader
                        class="text-body-2 font-weight-bold"
                        :key="`${key}-${j}`"
                        >{{ key }} ({{ getItems(key).length }})</v-subheader
                    >
                    <template v-for="(item, index) in getItems(key)">
                        <v-list-item :key="`item-${index}-${key}-${j}`">
                            <v-row no-gutters class="px-0 mx-0 my-1">
                                <v-col cols="1" class="align-start">
                                    <v-icon>{{ getIcon(key) }}</v-icon>
                                </v-col>
                                <v-col cols="5">
                                    <span class="body-2">{{ item.value }}</span>
                                </v-col>
                                <v-col cols="6">
                                    <template
                                        v-for="(source, i) in item.sources"
                                    >
                                        <v-chip
                                            color="grey lighten-3"
                                            :key="`${key}-source-${i}`"
                                            small
                                            class="caption my-1 mx-1 primary--text text--darken-3"
                                            >{{ source }}</v-chip
                                        >
                                    </template>
                                </v-col>
                            </v-row>
                        </v-list-item>
                        <v-divider
                            :key="`divider-${key}-${index}-${j}`"
                        ></v-divider>
                    </template>
                </template>
            </v-list>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    name: "screening-process-summary",
    components: {},
    props: {
        id: {
            type: String,
            required: false,
            default: "screening-summary",
        },
        title: {
            type: String,
            required: false,
            default: "Summary",
        },
        icon: {
            type: String,
            required: false,
            default: "mdi-clipboard-list-outline",
        },
        headingColor: {
            type: String,
            required: false,
            default: "primary",
        },

        summaries: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {
        addresses() {
            return this.summaries.filter((val) => val.category === "Address");
        },
        names() {
            return this.summaries.filter((val) => val.category == "Name");
        },
        birthdates() {
            return this.summaries.filter((val) => val.category == "Birthdate");
        },
    },
    methods: {
        getItems(key) {
            return this[key.toLowerCase()];
        },
        getIcon(key) {
            switch (key) {
                case "Addresses":
                    return "mdi-home-map-marker";
                case "Names":
                    return "mdi-account";
                case "Birthdates":
                    return "mdi-calendar";
            }
        },
    },
};
</script>

<style scoped>
</style>